const bulkvapewholesale = {
    id: 'bulkvapewholesale',
    publicSiteName: 'Bulk Vape Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#5BC9E2',
            secondary: '#000000',
            color1: '#4ea9bf',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'minimal',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/bulkvapewholesale/favicon.ico',
        logo: '/bulkvapewholesale/logo.png',
    },
    features: {
        rewards: false,
        subscriptions: false,
    },
}

export default bulkvapewholesale